<template>

    <Card :title="$route.meta.title" dis-hover>
        <Row>
            <Col span="16">
                <Form ref="passwordForm" :model="passwordForm" :label-width="120">
                    <FormItem label="原密码" prop="oldPassword" :rules="[rules.required]" error="原密码">
                        <Input v-model="passwordForm.oldPassword" type="password" placeholder="原密码"></Input>
                    </FormItem>
                    <FormItem label="新密码" prop="password" :rules="[rules.required]">
                        <Input v-model="passwordForm.password" type="password" placeholder="新密码"></Input>
                    </FormItem>
                    <FormItem label="确认新密码" prop="confirmPassword" :rules="[rules.required]">
                        <Input v-model="passwordForm.confirmPassword" type="password" placeholder="确认新密码"></Input>
                    </FormItem>
                </Form>
                <div class="form-footer" style="text-align: left;margin-left: 120px;">
                    <Button type="primary" @click="handleSubmit">修改</Button>
                </div>
            </Col>
        </Row>
    </Card>

</template>
<script>
    import _don from '@/libs/doson'
    import rules from '@/libs/rules';
    import iUser from '@/module/base/api/iUser'

    export default {
        name: "password_mng",
        mixins: [],
        components: {
        },
        data() {
            return {
                rules,
                passwordForm:{
                    oldPassword:null,
                    password:null,
                    confirmPassword:null,
                }
            }
        },
        mounted() {
            this.$refs.passwordForm.resetFields();
        },
        methods: {
            handleSubmit() {
                this.$refs.passwordForm.validate(val => {
                    if (!val) return;
                    // 清除空字符串
                    if (this.passwordForm.password != this.passwordForm.confirmPassword) {
                        this.$Message.error('两次输入的密码不一致')
                        return
                    }
                    iUser.updatePassword(this.passwordForm.oldPassword, this.passwordForm.password).then(() => {
                        this.$Message.success('操作成功');
                    });
                });
            }
        }
    }
</script>

<style scoped lang="less">

</style>
